<template>
  <div>
    <div class="footer">Copyright © 2022 Nantong Wang and sheng Textile Co., Ltd All rights reserved.</div>
<!--    <common-user-fix />-->
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .footer {
    position: fixed;
    bottom: 0;
    font-size: 16px;
    font-family: Poppins;
    font-weight: 400;
    color: #FFFFFF;
    background: #036EB8;
    padding: 10px 0;
    text-align: center;
    width: 100%;
    height: 50px;
  }
</style>




// WEBPACK FOOTER //
// footer.vue?ba8fe8ce